import React from "react";
import pic1 from "../assets/3.jpg";
import pic2 from "../assets/Rectangle 4404.png";
import icon1 from "../assets/plant.png";
import icon2 from "../assets/farming.png";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function Crops({ scrollRef }) {
  return (
    <div className="mx-auto w-[90%] py-10">
      <motion.div
        ref={scrollRef}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ root: scrollRef, once: true }}
        className="text-primary font-bold text-3xl lg:text-5xl text-center mb-10 lg:mb-16"
      >
        المـــــــــحاصـــــيـــل
      </motion.div>

      {/* Section 1: Image Right / Text Left */}
      <div className="flex flex-col-reverse lg:flex-row items-center gap-10 mb-20">
        <motion.div
          ref={scrollRef}
          initial={{ opacity: 0, x: -75 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ root: scrollRef, once: true }}
          className="lg:w-1/2 text-center flex flex-col gap-6"
        >
          <img src={icon2} alt="" className="w-[57px] h-[57px] mx-auto" />
          <span className="text-4xl font-extrabold">العروض</span>
          <p className="text-[#999797] text-2xl font-medium">
            استعرض مجموعة متنوعة من المحاصيل المتاحة للشراء وقم بعملية شراء سلسة
          </p>
          <Link to="/home/cropsOffers">
            <div className="w-[11rem] bg-primary text-white font-bold p-3 rounded-[17.5px] mx-auto">
              إعرف المزيد
            </div>
          </Link>
        </motion.div>
        <motion.div
          ref={scrollRef}
          initial={{ opacity: 0, x: 75 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ root: scrollRef, once: true }}
          className="lg:w-1/2"
        >
          <img src={pic1} alt="العروض" className="w-full rounded-2xl" />
        </motion.div>
      </div>

      {/* Section 2: Image Left / Text Right */}
      <div className="flex flex-col lg:flex-row items-center gap-10">
        <motion.div
          ref={scrollRef}
          initial={{ opacity: 0, x: -75 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ root: scrollRef, once: true }}
          className="lg:w-1/2"
        >
          <img src={pic2} alt="الطلبات" className="w-full rounded-2xl" />
        </motion.div>
        <motion.div
          ref={scrollRef}
          initial={{ opacity: 0, x: 75 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ root: scrollRef, once: true }}
          className="lg:w-1/2 text-center flex flex-col gap-6"
        >
          <img src={icon1} alt="" className="w-[57px] h-[57px] mx-auto" />
          <span className="text-4xl font-extrabold">الطلبات</span>
          <p className="text-[#999797] text-2xl font-medium">
            قم بعرض محاصيلك الزراعية و أحصل على مشتري في أسرع زمن
          </p>
          <Link to="/home/cropsBuy">
            <div className="w-[11rem] bg-primary text-white font-bold p-3 rounded-[17.5px] mx-auto">
              إعرف المزيد
            </div>
          </Link>
        </motion.div>
      </div>
    </div>
  );
}

export default Crops;
